import { loadStripe } from '@stripe/stripe-js';

// Loaded once and reused -- loadStripe() itself caches the underlying
// script tag, but memoizing the promise here avoids re-triggering it on
// every CardSetup mount (e.g. if the CSR starts a new order).
let stripePromise;

export function getStripe() {
  if (!stripePromise) {
    const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
    if (!key) {
      // Fails loudly in the UI (see CardSetup.jsx) rather than silently
      // never rendering a card field -- same philosophy as backend config.js.
      // eslint-disable-next-line no-console
      console.error('VITE_STRIPE_PUBLISHABLE_KEY is not set -- card collection will not work.');
    }
    stripePromise = loadStripe(key);
  }
  return stripePromise;
}
